import { message } from './message'

function resolveErrorText(input: unknown, fallback: string) {
  if (typeof input === 'string' && input.trim() !== '') {
    return input
  }

  if (input instanceof Error && input.message.trim() !== '') {
    return input.message
  }

  return fallback
}

/**
 * The toast for a failure with nobody waiting on it — background work that started itself. It
 * stays up 15s and carries a close button, because there is no action in progress to draw the
 * eye to it.
 *
 * A failure the user caused is not this. A mutation's own `onError` reports through
 * `showMutationError`, which stays quiet when the axios interceptor has already spoken
 * for a 5xx; a plain outcome is `message.error`. This one always speaks.
 *
 * `input` may be the sentence itself, an `Error`, or anything at all — a blank string and
 * a bare `Error` both fall back to `fallback`, so the caller need not check first.
 */
export function showGlobalError(input: unknown, fallback: string) {
  message.error(resolveErrorText(input, fallback), {
    duration: 15000,
    showClose: true
  })
}
